var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalentIdTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 127,
    zoomAndPan: "magnify",
    viewBox: "0 0 95.25 48",
    height: 64,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "75bf12c5cd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.605469 0 L 93.910156 0 L 93.910156 47.019531 L 0.605469 47.019531 Z M 0.605469 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4ee9745d4c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.605469 8.964844 L 93.910156 8.964844 L 93.910156 38.058594 L 0.605469 38.058594 Z M 0.605469 8.964844 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#75bf12c5cd)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.734694, 0, 0, 0.734694, 0.604591, 0.00000308465)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00119411 -0.00000419855 L 126.999245 -0.00000419855 L 126.999245 63.998804 L 0.00119411 63.998804 Z M 0.00119411 -0.00000419855 ",
    stroke: "#fcfcfc",
    strokeWidth: 6,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4ee9745d4c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.605469 8.964844 L 93.910156 8.964844 L 93.910156 38.058594 L 0.605469 38.058594 Z M 0.605469 8.964844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fcfcfc",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.498724, 30.12245)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 5.046875 -13.1875 L 0.34375 -13.1875 L 0.34375 -15.765625 L 12.8125 -15.765625 L 12.8125 -13.1875 L 8.109375 -13.1875 L 8.109375 0 L 5.046875 0 Z M 5.046875 -13.1875 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#fcfcfc",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.652172, 30.12245)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.015625 -2.078125 L 1.015625 -4.640625 L 3.09375 -6.71875 L 8.78125 -6.71875 L 8.78125 -8.140625 L 8.09375 -8.828125 L 4.703125 -8.828125 L 4.03125 -8.140625 L 4.03125 -7.5 L 1.109375 -7.5 L 1.109375 -8.78125 L 3.515625 -11.21875 L 9.3125 -11.21875 L 11.71875 -8.78125 L 11.71875 0 L 9.03125 0 L 9.03125 -1.59375 L 7.375 0 L 3.09375 0 Z M 7.171875 -2.296875 L 8.78125 -3.859375 L 8.78125 -4.59375 L 4.546875 -4.59375 L 3.9375 -3.984375 L 3.9375 -2.859375 L 4.5 -2.296875 Z M 7.171875 -2.296875 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#fcfcfc",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.602912, 30.12245)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.46875 -16.09375 L 4.4375 -16.09375 L 4.4375 0 L 1.46875 0 Z M 1.46875 -16.09375 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#fcfcfc",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.503949, 30.12245)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.125 -2.296875 L 1.125 -8.875 L 3.453125 -11.21875 L 9.78125 -11.21875 L 12.125 -8.875 L 12.125 -4.625 L 4.09375 -4.625 L 4.09375 -3.171875 L 4.828125 -2.4375 L 8.5 -2.4375 L 9.171875 -3.125 L 9.171875 -3.71875 L 12.09375 -3.71875 L 12.09375 -2.25 L 9.875 0 L 3.40625 0 Z M 9.140625 -6.6875 L 9.140625 -8 L 8.375 -8.78125 L 4.859375 -8.78125 L 4.09375 -8 L 4.09375 -6.6875 Z M 9.140625 -6.6875 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#fcfcfc",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.634875, 30.12245)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.359375 -11.21875 L 4.09375 -11.21875 L 4.09375 -9.34375 L 5.96875 -11.21875 L 9.59375 -11.21875 L 12.09375 -8.71875 L 12.09375 0 L 9.125 0 L 9.125 -7.90625 L 8.359375 -8.703125 L 6.46875 -8.703125 L 4.328125 -6.53125 L 4.328125 0 L 1.359375 0 Z M 1.359375 -11.21875 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#fcfcfc",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.96851, 30.12245)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.359375 -2.296875 L 2.359375 -8.71875 L 0.34375 -8.71875 L 0.34375 -11.21875 L 2.40625 -11.21875 L 2.40625 -14.875 L 5.34375 -14.875 L 5.34375 -11.21875 L 8.765625 -11.21875 L 8.765625 -8.703125 L 5.34375 -8.703125 L 5.34375 -3.265625 L 6.109375 -2.53125 L 8.765625 -2.53125 L 8.765625 0 L 4.6875 0 Z M 2.359375 -2.296875 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#fcfcfc",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.293044, 30.12245)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.578125 -15.765625 L 4.640625 -15.765625 L 4.640625 0 L 1.578125 0 Z M 1.578125 -15.765625 "
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#fcfcfc",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.509399, 30.12245)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.46875 -15.765625 L 11.5625 -15.765625 L 14.265625 -13.0625 L 14.265625 -2.703125 L 11.5625 0 L 1.46875 0 Z M 10.046875 -2.609375 L 11.203125 -3.765625 L 11.203125 -12.015625 L 10.046875 -13.15625 L 4.53125 -13.15625 L 4.53125 -2.609375 Z M 10.046875 -2.609375 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentIdTransparent);
export default __webpack_public_path__ + "static/media/Talent_ID_Transparent.f9067b255aba8393cd659f7f5cac1fd3.svg";
export { ForwardRef as ReactComponent };